module.exports = __webpack_public_path__ + "static/idleonLogo-d896a09532a92795b2d89db162611e97.png";